import * as React from 'react';
import { connect } from 'react-redux';
import './Complete.css';
import { navigateTo } from '../../../actions/navigationActions';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import { showAnotherSelfInspection } from '../../../actions/modalActions';

class Complete extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {}

        this.handleChange = this.handleChange.bind(this);
        this.handleSwitch = this.handleSwitch.bind(this);
        this.submit = this.submit.bind(this);
        this.inspectAnotherVehicle = this.inspectAnotherVehicle.bind(this);
    }

    inspectAnotherVehicle(e: any) {
        this.props.showAnotherSelfInspection();
    }

    handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    async handleSwitch(e: any) {
        var checked = e.target.checked;
        await this.setState({ concent: checked });
    }

    submit(e: any) {
        this.setState({ submitted: true })

        if (this.state.upholsteryDamage && this.state.paintDamage && this.state.hailDamage && this.state.carRebuilt && this.state.concent) {
            this.props.dispatchSaveCarCondition(this.state.upholsteryDamage, this.state.paintDamage, this.state.hailDamage, this.state.carRebuilt)
        }
    }


    public render() {

        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Car" }]
        if (this.props.selfInspect.selectedPersonalCover && this.props.selfInspect.selectedPersonalCover.product === 7) {
            BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Motorbike" }]
        }

        let submitted = this.state.submitted
        return (
            <>
                <div id="CarComplete" className="container-fluid new-page-margins">
                    <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-conditions-actual">
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Self-inspection" />
                    </div>
                    <div className="row new-page-main-row">
                        <div className="new-content-box selfinspect-complete-container">
                            {/*/// Container Start ///*/}
                            <div className="capture-conditions-header">
                                <h3 className="carName mb-2">{this.props.selfInspect.selectedPersonalCover.product === 7 ? 'Motorbike inspection' : 'Car inspection'}</h3>
                                <p className="Step-Description mb-4">{this.props.selfInspect.selectedPersonalCover.riskItems[0].description}</p>
                            </div>
                            <div className="row capture-details-header-bottom-border"></div>
                            {/*///  SSP Vertical Progress Bar Container ///*/}
                            {/*/// Change row class ssp-vpb-step-done-or-current to ssp-vpb-step-done / ssp-vpb-step-current ///*/}
                            <div className="ssp-vertical-progressbar-container">
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>Snap a photo</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>{this.props.selfInspect.selectedPersonalCover.product === 7 ? 'Motorbike details' : 'Car details'}</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>T's & C's</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <div className="selfinspect-complete-container-step-content">
                                            <div className="selfinspect-complete-step-header">
                                                <h3>Inspection completed</h3>
                                                <p>You’ve completed your self-inspection</p>
                                            </div>
                                            <hr />
                                            <p className="selfinspect-complete-text-thanks">Thanks!</p>
                                            <p className="selfinspect-complete-text-inspect-another">Ready to inspect another car/motorbike? Just tap here:</p>
                                            <button className="btn btn-outline-red w-100" onClick={this.inspectAnotherVehicle} id="InspectAnotherVehicle">Inspect another car/motorbike</button>
                                        </div>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/* /// End Vertical Progress Steps ///*/}
                            </div>
                            {/*/// End SSP Vertical Progress Bar Container ///*/}
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        selfInspect: state.selfInspect,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {

        showAnotherSelfInspection: () => dispatch(showAnotherSelfInspection())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Complete);